import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "relative flex-1 min-w-[200px] max-w-md" }
const _hoisted_2 = {
  key: 0,
  class: "absolute z-50 w-full mt-1 bg-white border border-gray-300 rounded-lg shadow-lg max-h-60 overflow-auto"
}
const _hoisted_3 = {
  key: 0,
  class: "px-4 py-3 text-center text-sm text-gray-500"
}
const _hoisted_4 = {
  key: 1,
  class: "divide-y divide-gray-100"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "font-medium text-gray-900 block truncate" }
const _hoisted_7 = { class: "text-sm text-gray-500 block truncate" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "text-xs text-gray-400 font-mono" }
const _hoisted_10 = {
  key: 2,
  class: "px-4 py-3 text-center text-gray-500 text-sm"
}

import { ref, watch } from 'vue'
import { useAdminEfpStore } from '@/stores/adminEfp'
import type { AdminEfpAcheteur } from '@/api/adminEfp'
import AdminAcheteurDetailsModal from '@/components/adminEFP/AdminAcheteurDetailsModal.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'AdminAcheteurSearch',
  setup(__props) {

const adminEfp = useAdminEfpStore()

const searchTerm = ref('')
const results = ref<AdminEfpAcheteur[]>([])
const showDropdown = ref(false)
const loading = ref(false)
const searchContainerRef = ref<HTMLElement | null>(null)
const detailsModalRef = ref<InstanceType<typeof AdminAcheteurDetailsModal> | null>(null)

let debounceTimer: ReturnType<typeof setTimeout> | null = null

async function fetchResults() {
  const term = searchTerm.value.trim()
  if (term.length < 2) {
    results.value = []
    return
  }
  loading.value = true
  try {
    results.value = await adminEfp.autocompleteAcheteurs(term)
  } catch {
    results.value = []
  } finally {
    loading.value = false
  }
}

function onSearchInput() {
  if (debounceTimer) clearTimeout(debounceTimer)
  debounceTimer = setTimeout(fetchResults, 250)
}

function selectAcheteur(a: AdminEfpAcheteur) {
  showDropdown.value = false
  searchTerm.value = ''
  results.value = []
  detailsModalRef.value?.open(a.id_acheteur)
}

function handleClickOutside(e: MouseEvent) {
  if (searchContainerRef.value?.contains(e.target as Node)) return
  showDropdown.value = false
}

watch(showDropdown, (open) => {
  if (open) {
    document.addEventListener('click', handleClickOutside)
  } else {
    document.removeEventListener('click', handleClickOutside)
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "searchContainerRef",
    ref: searchContainerRef,
    class: "admin-acheteur-search"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" }, [
        _createElementVNode("i", { class: "fas fa-search text-gray-400 text-sm" })
      ], -1)),
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchTerm).value = $event)),
        type: "text",
        autocomplete: "off",
        class: "block w-full pl-9 pr-3 py-2 text-sm border border-gray-300 rounded-lg bg-white placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500",
        placeholder: "Rechercher un acheteur…",
        onInput: onSearchInput,
        onFocus: _cache[1] || (_cache[1] = ($event: any) => (showDropdown.value = true))
      }, null, 544), [
        [
          _vModelText,
          searchTerm.value,
          void 0,
          { trim: true }
        ]
      ]),
      (showDropdown.value && (loading.value || results.value.length > 0 || searchTerm.value.length >= 2))
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (loading.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, _cache[2] || (_cache[2] = [
                  _createElementVNode("i", { class: "fas fa-spinner fa-spin mr-2" }, null, -1),
                  _createTextVNode(" Recherche… ")
                ])))
              : (results.value.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(results.value, (a) => {
                      return (_openBlock(), _createElementBlock("button", {
                        key: a.id_acheteur,
                        type: "button",
                        class: "w-full text-left px-4 py-3 hover:bg-gray-50",
                        onClick: ($event: any) => (selectAcheteur(a))
                      }, [
                        _createElementVNode("span", _hoisted_6, _toDisplayString(a.nomSociete || `Acheteur #${a.id_acheteur}`), 1),
                        _createElementVNode("span", _hoisted_7, [
                          _createTextVNode(_toDisplayString([a.prenomContact, a.nomContact].filter(Boolean).join(' ')) + " ", 1),
                          (a.email)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_8, " · " + _toDisplayString(a.email), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("span", _hoisted_9, "#" + _toDisplayString(a.id_acheteur), 1)
                      ], 8, _hoisted_5))
                    }), 128))
                  ]))
                : (searchTerm.value.length >= 2)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, " Aucun acheteur trouvé "))
                  : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(AdminAcheteurDetailsModal, {
      ref_key: "detailsModalRef",
      ref: detailsModalRef
    }, null, 512)
  ], 512))
}
}

})